import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import Checkbox from '../../../../components/forms/Checkbox'
import VariousMaterielAction from '../../../../materiel/components/variousMateriel/actions/VariousMaterielAction'
import VariousMaterielDto from '../../../../materiel/components/variousMateriel/dto/VariousMaterielDto'
import ToastrAction from '../../../../toastr/actions/ToastrAction'
import { setModal } from '../../../../utils/FormUtils'
import Job from '../../../dto/DtoJob'
import ImportFileModal from './ImportFileModal'
import { exportFile } from '../../../../utils/ExportDataUtil'
import { nbPerPageLabelMedium } from '../../../../referencial/constants/ReferencialConstants'
import { CardTable } from '../../../../components/datatable/NewTable'

class ImportCalypsoPanel extends Component {
    constructor(props) {
        super(props)
        const [param = '{}'] = props.job.parameters.parameters
        this.state = {
            directory: undefined,
            filter: undefined,
            type: undefined,
            rename: false,
            codes: [],
            ...JSON.parse(param),
        }
    }

    componentDidMount() {
        if (!this.props.variousMateriels.length) {
            this.props.fetchVariousMateriels()
        }
    }

    onChangeParameter = obj => {
        const newParameter = {
            ...this.state,
            ...obj,
        }
        this.setState(newParameter)
        this.props.handleChangeParameters([JSON.stringify(newParameter)])
    }

    getDataTypes = type => {
        const { parameters } = this.props.job
        if (parameters.dataTypes && parameters.dataTypes.length) {
            return parameters.dataTypes.find(d => d.includes(type)) || ''
        }
        return ''
    }

    setAdvancedFtpModal =() => {
        setModal({
            title: i18n.importParam,
            content: <ImportFileModal url={this.state.directory} onChange={name => this.setState({ filter: name }) } />,
        })
    }

    getStations = () => {
        return this.state.codes.map((v) => ({ credentials: v }))
    }


    handleChangeStationIntegration = integration => {
        const { parameters } = this.props.job
        const newDataTypes = (() => {
            const data = parameters.dataTypes.filter(d => !d.includes('station'))
            if (integration) {
                return [...data, 'stationIntegration']
            }
            return data
        })()
        this.props.onChangeDataTypes(newDataTypes)
    }

    addCode = () => {
        if (this.props.isEditMode) {
            const code = this.refs.txtAddCode.value
            const exist = this.state.codes.find(p => p === code)
            const matExist = this.props.variousMateriels.find(mat => mat.reference === code)
            if (!code) {
                this.props.toastrError(i18n.youMustEnterAtLeastOneCode)
            } else if (exist) {
                this.props.toastrError(i18n.youHaveAlreadyEnteredThisCode)
            } else if (!matExist) {
                this.props.toastrError(i18n.matNotExist)
            } else {
                this.onChangeParameter({ codes: [... this.state.codes, code] })
                this.refs.txtAddCode.value = ''
            }
        }
    }

    onDeleteCode = (s) => {
        this.onChangeParameter({ codes: this.state.codes.filter(p => p !== s.credentials) })
    }

    render() {
        const disabled = { disabled: !this.props.isEditMode }
        const myData =this.getStations()
        return (
            <div>
                <div className='row no-margin valign-wrapper'>
                    <div className='col s3'>
                        <Checkbox
                            checked={this.state.rename}
                            label={i18n.fileRenaming}
                            onChange={v => this.onChangeParameter({ rename: v })}
                            {...disabled}
                        />
                    </div>
                </div>
                <div className='row no-margin valign-wrapper'>
                    <div className=' input-field col s3'>
                        <label>{i18n.defineDirectory}</label>
                    </div>
                    <div className='input-field col s9'>
                        <input
                            id='txtDirDef'
                            type='text'
                            value={this.state.directory}
                            onChange={e => this.props.isEditMode && this.onChangeParameter({ directory: e.target.value })}
                            placeholder={i18n.selectDirectory}
                            {...disabled}
                        />
                        <a className='btn btn-small secondary-color-back' onClick={ () => this.setAdvancedFtpModal()} {...disabled} ><span title={ i18n.importLabelFtp }> <i className='material-icons'>input </i> </span></a>
                    </div>
                </div>
                <div className='row no-margin valign-wrapper'>
                    <div className='input-field col s3'>
                        <label>{i18n.filter}</label>
                    </div>
                    <div className='input-field col s9'>
                        <input
                            id='txtFilter'
                            type='text'
                            value={this.state.filter}
                            onChange={e => this.props.isEditMode && this.onChangeParameter({ filter: e.target.value })}
                            placeholder={i18n.filterExampleQuesu}
                            {...disabled}
                        />
                    </div>
                </div>

                <div className='row no-margin valign-wrapper'>
                    <div className='col s3'><label>{ i18n.addCredential }</label></div>
                    <div className='input-field col s9 no-padding'>
                        <div className='col s8'>
                            <input id='txtAddCode' type='text' placeholder={ i18n.matExample } ref='txtAddCode' {...disabled}/>
                            <label className='tinyLabel'>{ i18n.matCode }</label>
                        </div>
                        <a className='waves-effect waves-light btn col offset-s1 s3' onClick={ this.addCode } {...disabled}>{ i18n.add }</a>
                    </div>
                </div>
                <div className='row valign-wrapper'>
                    <div className='col s12'>
                        <CardTable
                            rows={ myData }
                            headers={ ['credentials']}
                            title={ i18n.credentials }
                            lineActions={[{
                                icon: 'delete',
                                onClick: (s) => this.onDeleteCode(s),
                                displayed: this.props.isEditMode,
                            }]}
                            rowsPerPageOptions={ nbPerPageLabelMedium }
                            data-cy='calypso_table_body'
                            actions={[{
                                icon: 'download',
                                onClick: () => exportFile({
                                    data: [{ ...(myData[0]), headers: ['credentials'] }, ...(myData.slice(1, myData.length))],
                                    titleFile: i18n.credentials,
                                }),
                                tooltip: i18n.download,
                            }]}
                            displayHeaders={false}
                        />
                    </div>
                </div>

            </div>
        )
    }
}

ImportCalypsoPanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    isEditMode: PropTypes.bool,
    handleChangeParameters: PropTypes.func.isRequired,
    onChangeDataTypes: PropTypes.func.isRequired,
    variousMateriels: PropTypes.arrayOf(PropTypes.instanceOf(VariousMaterielDto)),
    toastrError: PropTypes.func,
    fetchVariousMateriels: PropTypes.func,
}

const mapStateToProps = store => ({
    variousMateriels: store.VariousMaterielReducer.variousMateriels,
})

const mapDispatchToProps = {
    toastrError: ToastrAction.error,
    fetchVariousMateriels: VariousMaterielAction.fetchVariousMateriels,
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportCalypsoPanel)
